import { Component } from '@angular/core';

/**
 * Section toolbar: a title (projected) on one side and caller-projected actions on the other.
 * The row that basically every page section needs — a title with an optional action bar.
 *
 * Project trailing controls into the actions slot:
 * `<sb-section-toolbar>Title<button section-toolbar-actions …></button></sb-section-toolbar>`.
 */
@Component({
  selector: 'sb-section-toolbar',
  host: {
    class: '@container block',
  },
  template: `
    <div class="flex flex-col justify-between gap-sm @md:flex-row @md:items-center">
      <h2 class="reset-h text-lg font-semibold text-default empty:hidden">
        <ng-content />
      </h2>

      <div class="flex min-w-0 items-center gap-sm empty:hidden">
        <ng-content select="[section-toolbar-actions]" />
      </div>
    </div>
  `,
})
export class SectionToolbarComponent {}
